import { createRootRouteWithContext } from "@tanstack/react-router";
import { IAuthContext } from "../context/auth-context";
import { RootView } from "../views/root/root-view";

interface RouterContext {
  authentication: IAuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootView,
});
